module.exports = __webpack_public_path__ + "img/mariage-lazy.0e20b303.jpg";